import React, { Suspense, lazy, useRef, useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { TrackPageView } from './utilities/insights';
import _ from 'lodash';
import Header from './layout/Header';
import Footer from './layout/Footer';

import { Home, Dashboard, Browse, QRcode, Help, NotFound, Callback, NotAuth } from './screens';
import { withAuth } from 'components/WithAuth';
import './App.css';
import { useDispatch, useSelector } from 'react-redux';
import { setMobile } from 'redux/actions/site';
import { getSiteIds } from 'redux/thunks';
import MyDashboards from 'screens/MyDashboards';
import MenuDrawer from 'layout/MenuDrawer';
import AppLoader from 'components/Loader';

const ManagerPortal = lazy(() => import('./screens/ManagerPortal/ManagerPortal'));

const App = () => {
    const location = useLocation();
    let path = useRef('');
    const dispatch = useDispatch();
    const admin = useSelector((state) => state.user.admin);
    const userName = useSelector((state) => state.user.userName);
    const email = useSelector((state) => state.user.email);
    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        dispatch(getSiteIds());
        const debouncedHandleResize = _.debounce(() => {
            window.innerWidth < 755 ? dispatch(setMobile(true)) : dispatch(setMobile(false));
        }, 500);
        debouncedHandleResize();
        window.addEventListener('resize', debouncedHandleResize);

        return () => {
            window.removeEventListener('resize', debouncedHandleResize);
        };
    }, [dispatch]);

    // APP INSIGHTS: Track Page Changed
    useEffect(() => {
        if (path.current !== location.pathname) {
            TrackPageView(location.pathname, userName, email);
        }
    }, [location, userName, email, dispatch]);

    return (
        <div className='App'>
            <Header openMenu={() => setShowMenu(true)} />
            <MenuDrawer open={showMenu} onClose={() => setShowMenu(false)} />
            <div className='app-content'>
                <Switch>
                    <Route exact path='/' component={Home} />
                    <Route path='/help' component={Help} />

                    {/* TODO create private/protected route component */}
                    <Route path='/mydashboards' component={MyDashboards} />
                    <Route path='/site/:siteId/dashboard/:dashboardId/qr-code' component={QRcode} />
                    <Route path='/site/:siteId/dashboard/:dashboardId' component={Dashboard} />

                    <Route path='/search'>
                        {/* FIXME we should probably replace the suspense component because it is an experimental component, so it could break if we update versions of react */}
                        <Suspense fallback={<AppLoader />}>
                            <Browse />
                        </Suspense>
                    </Route>
                    <Route path='/managerportal'>
                        <Suspense fallback={<AppLoader />}>{admin ? <ManagerPortal /> : <NotAuth />}</Suspense>
                    </Route>
                    <Route path='/callback' component={Callback} />
                    <Route path='*' component={NotFound} />
                </Switch>
            </div>
            <Footer />
        </div>
    );
};

export default withAuth(App);
